import { render, staticRenderFns } from "./shortVideo_list.vue?vue&type=template&id=57c2c9ec&scoped=true"
import script from "./shortVideo_list.vue?vue&type=script&lang=js"
export * from "./shortVideo_list.vue?vue&type=script&lang=js"
import style0 from "./shortVideo_list.vue?vue&type=style&index=0&id=57c2c9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2c9ec",
  null
  
)

export default component.exports